import { z } from "zod";

/**
 * Declares which human-in-the-loop actions a surface offers. The frontend's
 * `InterruptCard` renders one button per allowed flag (Approve / Reject /
 * Respond / Edit), and the langgraph harness emits the same shape on
 * `interrupt(...)`. Canonical home is here in `shared` so the backend graph,
 * the artifact schemas, and the frontend speak one vocabulary.
 *
 * NOTE: `use-langgraph-stream` (`humanInterrupt.ts`) and
 * `langgraph_app/app/core/harness/registry/types.ts` each carry a structurally
 * identical copy today; they should converge on this one.
 */
export const humanInterruptConfigSchema = z.object({
  allow_ignore: z.boolean(), // "Reject" — decline without abandoning the thread
  allow_respond: z.boolean(), // free-text response
  allow_edit: z.boolean(),
  allow_accept: z.boolean(), // "Approve"
});
export type HumanInterruptConfig = z.infer<typeof humanInterruptConfigSchema>;
